export const getPinTargetType = (item: { type?: string; item_type?: string }) =>
  item?.type === 'folder' || item?.item_type === 'folder' ? 'folder' : 'videofeed';

export const reorderPinnedItems = <T extends { id: string | number }>(
  items: T[],
  draggedId: string | number,
  targetId: string | number,
) => {
  const next = [...items];
  const fromIndex = next.findIndex((item) => String(item.id) === String(draggedId));
  const toIndex = next.findIndex((item) => String(item.id) === String(targetId));

  if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) {
    return next;
  }

  const [moved] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, moved);
  return next;
};
